import type { RouteObject } from "react-router";

import PatientSystemicMapPage from "./ui/pages/PatientSystemicMapPage";
import TherapistSystemicMapPage from "./ui/pages/TherapistSystemicMapPage";

/**
 * Therapist route — mounted INSIDE the protected app shell.
 *
 * One route, the board itself. There is deliberately no list page: a map is
 * reached from the tool dock, which already knows which patient is in front of
 * you, and a sidebar entry would land on a list with no such context.
 */
export const systemicMapRoutes: RouteObject[] = [
    { path: "/systemic-map/:mapId", element: <TherapistSystemicMapPage /> },
];

/**
 * The therapist's map with no app chrome, framed inside a call — see the
 * constellation's route of the same name.
 */
export const systemicMapMeetingRoutes: RouteObject[] = [
    { path: "/meeting-board/systemic-map/:mapId", element: <TherapistSystemicMapPage embedded /> },
];

// Patient route — PUBLIC, mounted OUTSIDE ProtectedRoute/AppLayout. The token
// is the authorisation; there is no account behind it.
export const systemicMapPublicRoutes: RouteObject[] = [
    { path: "/systemic-map/patient/:token", element: <PatientSystemicMapPage /> },
];
